var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('row',[_c('col12',[_c('user-limits',{attrs:{"headerType":"myProfile"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }